"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.PlusIcon20Solid = forwardRef_1.forwardRef('PlusIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M9.5 2A1.5 1.5 0 0 1 11 3.5V9h5.5a1.5 1.5 0 0 1 0 3H11v5.5a1.5 1.5 0 0 1-3 0V12H2.5a1.5 1.5 0 0 1 0-3H8V3.5A1.5 1.5 0 0 1 9.5 2Z" })));
});
